const AlertLevel = {
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
};

export default AlertLevel;
